export enum PAGES {
  'SEARCH-PROVIDERS' = 'landing',
  'SEARCH-RESULTS' = 'result',
  'SEARCH-RESULTS-NEXT' = 'result', //To do cleanup this, after CAA API Segregration is stable
  'PROVIDER-DETAILS' = 'detail',
  'CARE-PROVIDERS' = 'careteam'
}
